import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private httpClient: HttpClient) { }

  errorHandler(error:any) {
    let errorMessage = '';
    if(error instanceof HttpErrorResponse) {
      errorMessage = error.error;
    } else {
      errorMessage = error;
    }
    return throwError(errorMessage);
  }


  productes(category:any = null){
    let url = environment.apiURL +'productes';
    if(category){
      url = environment.apiURL +'productes?cat='+category;
    }

    return this.httpClient.get( url).pipe(
      catchError(this.errorHandler)
    )
  }
  productCategorys(){
    return this.httpClient.get( environment.apiURL +'categories').pipe(
      catchError(this.errorHandler)
    )
  }
  product(id:number){
    return this.httpClient.get( environment.apiURL +'product/'+id).pipe(
      catchError(this.errorHandler)
    )
  }

  downloadPDF(id:any){
    let url = environment.apiURL+"create-pdf/"+id;
    return this.httpClient.get(url,{
      responseType: 'arraybuffer'})
    .pipe(
      catchError(this.errorHandler)
    )
  }
}
